import { useRef } from "react"
import { useAnimationFrame } from "../util"

import useStore from "../AppStore"

function Line({velo,height,offset,guide}) {
  
  const lineRef = useRef(null)

  useAnimationFrame(clock => {
    const top = useStore.getState().top
    const y = 2000 - ((top + offset + clock.elapsedTime*20) * velo % 2000) - height
    if(lineRef.current){
      lineRef.current.style.transform = `translate3d(0px,${y}px,0)`
      lineRef.current.style.height = `${height}px`
    }
  })
  return (<div ref={lineRef} className={`line ${guide ? 'right' : 'left'}`} />)
}

export default function Lines (props) {
  return (
    <div className="lines">
      <Line velo={1} height={100} offset={0} guide={0} />
      <Line velo={2} height={20} offset={400} guide={0} />
      <Line velo={2} height={10} offset={800} guide={0} />
      <Line velo={2} height={50} offset={1000} guide={0} />
      <Line velo={1.5} height={50} offset={200} guide={1} />
      <Line velo={1.5} height={20} offset={500} guide={1} />
      <Line velo={1.5} height={10} offset={900} guide={1} />
      <Line velo={1.5} height={50} offset={1000} guide={1} />
    </div>
  )
}